import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'app/client-core/services/user.service';

@Pipe({
  name: 'clientSettingsValue'
})
export class ClientSettingsValuePipe implements PipeTransform {

  constructor(
    private userService: UserService
  ) {

  }
  transform(value: any): string {
    const settings = this.userService._getCachedClientSettings();
    if (!settings || settings.length === 0) {
      return '';
    }

    const config = settings.find(s => s.name === value)
    if (config) {
      return config.value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/client-settings-value.pipe.ts